import CampaignContentUpdateForm from "./CampaignContentUpdateForm"

export default CampaignContentUpdateForm
